var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54967 4.7125C2.54134 5.94583 1.87467 7.47083 1.70801 9.14583H3.39134C3.54134 7.92917 4.02467 6.82083 4.74134 5.89583L3.54967 4.7125ZM9.16634 3.37083V1.6875C7.49134 1.85417 5.96634 2.52083 4.73301 3.52917L5.91634 4.72083C6.84134 4.00417 7.94967 3.52083 9.16634 3.37083ZM14.083 4.72083L15.2747 3.52917C14.0413 2.52083 12.508 1.85417 10.8413 1.6875V3.37083C12.0497 3.52083 13.158 4.00417 14.083 4.72083ZM16.608 9.14583H18.2913C18.1247 7.47083 17.458 5.94583 16.4497 4.7125L15.258 5.90417C15.9747 6.82083 16.458 7.92917 16.608 9.14583ZM8.82467 6.9875L10.9747 9.14583H5.83301V10.8125H10.9747L8.81634 12.9708L9.99967 14.1458L14.1663 9.97917L9.99967 5.8125L8.82467 6.9875ZM16.608 10.8125H18.2913C17.8747 15.0208 14.3247 18.3125 9.99967 18.3125C5.67467 18.3125 2.12467 15.0208 1.70801 10.8125H3.39134C3.79967 14.1042 6.59967 16.6458 9.99967 16.6458C13.3997 16.6458 16.1997 14.1042 16.608 10.8125Z",
    fill: "#1E2024"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloading);
export default __webpack_public_path__ + "static/media/downloading.b361327c08d761ec705aadcb2b7ba416.svg";
export { ForwardRef as ReactComponent };